module.exports = __webpack_public_path__ + "static/media/校园多楼宇综合供热5.5847c947.jpg";